export function mapSection() {
    let $parentBlock = $(".map-section");
    let $body = $("body");
    let $mapSvg = $(".map-states");
    let $mapModal = $(".map-modal");
    // let $accordionItems = $(".map-modal-inner");
    let modalWidth = 240;
    let distance = 180;
    let className;
    let showModal = function (id, context) {

        if ($(window).width() >= 768) {
            if ($(window).width() >= 1200) {
                modalWidth = 320;
                distance = 250;
            }

            if ($(window).width() >= 1440) {
                distance = 300;
            }

            let $state = $("#" + id);
            let top = $state.position().top - $mapSvg.position().top;
            let left = $state.position().left;
            $mapModal.removeClass("show");

            if (left < 150) {
                left = 170;
            } else if (($(window).width() - left) < distance) {
                left = left - modalWidth / 1.5;
            } else {
                left = $state.position().left - $mapSvg.position().left;
            }

            setTimeout(() => {
                $("[data-modal-id='"+ id +"']").css({
                    "top": top + "px",
                    "left": left + "px"
                }).addClass("show");
            }, 20);
        } else {
            $mapModal.removeClass("show");

            setTimeout(() => {
                $("[data-modal-id='"+ id +"']").addClass("show");
            }, 100);
        }
    };

    $mapModal.each(function () {
        let $item = $(this);

        if (!$item.hasClass("inactive")) {
            $("#" + $item.attr("data-modal-id")).addClass("highlighted active").css({
                "fill": $item.attr("data-color")
            });
        } else {
            $("#" + $item.attr("data-modal-id")).addClass("highlighted");
        }
    });

    let $highlightedStates = $(".highlighted");

    if ($body.hasClass("no-touch")) {
        $highlightedStates.on("click", function (e) {
            showModal($(this).attr("id"));
        });

        $highlightedStates.on("mouseenter", function (e) {
            if ($(this).attr("id") !== $(e.relatedTarget).attr("data-modal-id")) {
                showModal($(this).attr("id"));
            }
        });
    } else {
        $highlightedStates.on("click", function () {
            showModal($(this).attr("id"));
        });
    }

    $mapModal.on("mouseleave", function (e) {

        if ($(this).attr("data-modal-id") !== $(e.relatedTarget).attr("id")) {
            $mapModal.removeClass("show");

            $mapModal.css({
                "top": 0 + "px",
                "left": 0 + "px",
            });
        }
    });

    $(".map-form").on("change", function (e) {
        className = $(this).find(".jcf-select-text > span")
                    .attr("class");

        showModal(className.slice(className.length - 6, -1));
    });

    $body.on("click", function (e) {
        if (!$(e.target).hasClass("highlighted") && $(window).width() >= 768) {
            $mapModal.removeClass("show");

            $mapModal.css({
                "top": 0 + "px",
                "left": 0 + "px",
            });
        }
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/mapSection.js